import * as Yup from 'yup';

export const unitPlanFormSchema = Yup.object().shape({
  customer: Yup.object().shape({ customerID: Yup.string().required('Customer is required') }),
  office: Yup.object().shape({ officeID: Yup.string().required('Office is required') }),
  planName: Yup.string().required('Blue print name is required'),
  planFileTypeID: Yup.string().required('File type is required'),
});
